import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef } from '@angular/core';
import { equityDerMarginDetailModel } from './equityDerMarginDetail.model';
import { ButtonComponent } from '../../../../button/button.component';
import { FormComponent } from '../../../../form/form.component';
import { ServiceStock } from '../../../../service-stock.service';
import { HttpResponse } from '@angular/common/http';
import { InvestoridComponent } from '../../../components/Investorid/Investorid.component';
import { GotxGridComponent } from '../../../components/gotx-grid/gotx-grid.component';
import { gotxModalComponent } from 'src/app/gotxModal/gotxModal.component';
import { ViewChildren, QueryList } from '@angular/core';
import * as XLSX from 'xlsx';


const customCss: string = '';

@Component({
    selector: 'app-equityDerMarginDetail',
    templateUrl: './equityDerMarginDetail.component.html'
    
})

export class equityDerMarginDetailComponent extends FormComponent implements OnInit, AfterViewInit {
    @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
    @ViewChild('cstmInvestorID', { static: false }) cstmInvestorID: InvestoridComponent;
    @ViewChild('FieldId_2', { static: false }) FieldId_2: ButtonComponent;
    @ViewChild('btnEquityMarginDetailBack', {static: false}) btnEquityMarginDetailBack: ButtonComponent;
    @ViewChild('gotxGridComp',{ static: false})gotxGridComp: GotxGridComponent;
    @ViewChildren(GotxGridComponent) gotxGridComponents!: QueryList<GotxGridComponent>; //added by pooja
    
    @Output() selectedMenu = new EventEmitter<String>();
    @Input('params') params: any = null;
    marginsConsolidated: any[] = []; 
    
    staticOptions: any[] = []; 
    message: string;
    comGrid = "";
    hedgeMargin = "";
    GEQty = "";
    GEValue= "";
    GEMargin = "";
    totalMargin = "";
    specialMargin = "";
    additionalMargin = "";
    tenderMargin = "";
    adhocMargin = "";


    skeletonContentLoaded = false;
    async revalidate(): Promise<number> {
        var totalErrors = 0;
        super.beforeRevalidate();
        await Promise.all([
            this.cstmInvestorID.revalidate(),
        ]).then((errorCounts) => {
            errorCounts.forEach((errorCount) => {
                totalErrors += errorCount;
            });
        });
        this.errors = totalErrors;
        super.afterRevalidate();
        return totalErrors;
    }
    constructor(services: ServiceStock) {
        super(services);
        this.value = new equityDerMarginDetailModel();
        this.componentCode = 'equityMarginDetail';
    }
    setReadOnly(readOnly) {
        super.setBasicFieldsReadOnly(readOnly);
        this.cstmInvestorID.setReadOnly(readOnly);
    }
    async onFormLoad() {
        this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
        this.btnEquityMarginDetailBack.setFocus(true);
        this.setDependencies();
        if(this.params == "FUTOPT"){
            this.comGrid = "FUTOPT";
        }else if(this.params == "COMDERV"){
            this.comGrid = "COMDERV";
        }
    }
    setInputs(param: any) {
        let params = this.services.http.mapToJson(param);
        if (params['mode']) {
            this.mode = params['mode'];
        }
    }
    async submitForm(path, apiCode, serviceCode) {
        this.submitData['formName'] = 'equityMarginDetail';
        await super.submit(path, apiCode, serviceCode);
    }
    getFieldInfo() {
        this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
        this.additionalInfo['cstmInvestorID_desc'] = this.cstmInvestorID.getFieldInfo();
        return this.additionalInfo;
    }
    getFieldValue() {
        this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
        return this.value;
    }
    setValue(inputValue, inputDesc = undefined) {
        this.setBasicFieldsValue(inputValue, inputDesc);
        this.cstmInvestorID.setValue(inputValue['cstmInvestorID'], inputDesc['cstmInvestorID_desc']);
        this.value = new equityDerMarginDetailModel();
        this.value.setValue(inputValue);
        this.setDependencies();
        this.passNewValue(this.value);
    }
    ngOnInit() {
        if (this.formCode == undefined) { this.formCode = 'equityMarginDetail'; }
        if (this.formOnLoadError) { return; }
        setTimeout(() => {
            this.skeletonContentLoaded = true;
        }, 1000);
        var styleElement = document.createElement('style');
        styleElement.type = 'text/css';
        styleElement.innerHTML = customCss;
        styleElement.id = 'equityMarginDetail_customCss';
        document.getElementsByTagName('head')[0].appendChild(styleElement);
        this.services.dataStore.currentMessage.subscribe(message => {
            this.message = message;
        });
    }
    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        var styleElement = document.getElementById('equityMarginDetail_customCss');
        styleElement.parentNode.removeChild(styleElement);
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.subsBFldsValueUpdates();
            this.value.cstmInvestorID = this.cstmInvestorID.getFieldValue();
            this.cstmInvestorID.valueChangeUpdates().subscribe((value) => { this.value.cstmInvestorID = value; });
            this.onFormLoad();
            this.checkForHTabOverFlow();
            this.FieldId_2_click(null);
        });
    }
    clearError() {
        super.clearBasicFieldsError();
        super.clearHTabErrors();
        super.clearVTabErrors();
        this.cstmInvestorID.clearError();
        this.errors = 0;
        this.errorMessage = [];
    }
    onReset() {
        super.resetBasicFields();
        this.cstmInvestorID.onReset();
        this.clearHTabErrors();
        this.clearVTabErrors();
        this.errors = 0;
        this.errorMessage = [];
        this.additionalInfo = undefined;
        this.dependencyMap.clear();
        this.value = new equityDerMarginDetailModel();
        this.passNewValue(this.value);
        this.setReadOnly(false);
        this.onFormLoad();
    }
    async FieldId_2_click(event) {
        let inputMap = new Map();
        var errorCount: number = await this.revalidate();
        // let res ={"respCode":"0","errMsg":"","response":{"shortSellMarginList":[],"deliveryMarginList":[],"intraDayMarginList":[{"symbol":" ","displaySymbol":"ACIFORMULA  ","exchangeID":"CSE","openPosBuyQuantity":null,"openPosBuyValue":null,"openPosSellQuantity":null,"openPosSellValue":null,"netPosQuantity":null,"netPosValue":null,"outstandingBuyOrdQty":null,"outstandingBuyOrdVal":null,"outstandingSellOrdQty":null,"outstandingSellOrdVal":null,"marginHeld":1815.0,"currStlQty":null,"currStlVal":null,"currStlMarginHeld":null,"underStlQty":null,"underStlVal":null,"underStlMarginHeld":null,"underAucQty":null,"underAucVal":null,"underAucMarginHeld":null,"totalSSmarginHeld":null,"openPosQtyFromHoldings":null,"openPosShortQty":null,"openPosShortValue":null,"outstandingShortQty":null,"buyOrdermarginHeld":null,"hedgemargin":null,"totalMargin":null,"sigmaNetQty":null,"sigmaNetVal":null,"grossExposureMarginHeld":null,"fnoCarryForwardLineEntry":null,"underlyingLTP":null,"underlyingLastTrdDate":0,"underlyingLastTrdTime":0,"series":"  ","segment":"Delivery","buyTradeQuantity":0,"buyTradeValue":0.0,"sellTradeQuantity":0,"sellTradeValue":0.0,"shortSellTradeQty":0,"margincreditStockSale":0.0,"buyOrderQty":11,"buyOrderValue":-1815.0,"sellOrderQty":0,"sellOrderValue":0.0,"shortSellOrderQty":0,"shortSellMarginHeld":null,"specialMargin":null,"additionalMargin":null,"tenderMargin":null,"adhocMargin":null},{"symbol":" ","displaySymbol":"ABBANK      ","exchangeID":"CSE","openPosBuyQuantity":null,"openPosBuyValue":null,"openPosSellQuantity":null,"openPosSellValue":null,"netPosQuantity":null,"netPosValue":null,"outstandingBuyOrdQty":null,"outstandingBuyOrdVal":null,"outstandingSellOrdQty":null,"outstandingSellOrdVal":null,"marginHeld":121.0,"currStlQty":null,"currStlVal":null,"currStlMarginHeld":null,"underStlQty":null,"underStlVal":null,"underStlMarginHeld":null,"underAucQty":null,"underAucVal":null,"underAucMarginHeld":null,"totalSSmarginHeld":null,"openPosQtyFromHoldings":null,"openPosShortQty":null,"openPosShortValue":null,"outstandingShortQty":null,"buyOrdermarginHeld":null,"hedgemargin":null,"totalMargin":null,"sigmaNetQty":null,"sigmaNetVal":null,"grossExposureMarginHeld":null,"fnoCarryForwardLineEntry":null,"underlyingLTP":null,"underlyingLastTrdDate":0,"underlyingLastTrdTime":0,"series":"  ","segment":"Delivery","buyTradeQuantity":0,"buyTradeValue":0.0,"sellTradeQuantity":0,"sellTradeValue":0.0,"shortSellTradeQty":0,"margincreditStockSale":0.0,"buyOrderQty":11,"buyOrderValue":-121.0,"sellOrderQty":0,"sellOrderValue":0.0,"shortSellOrderQty":0,"shortSellMarginHeld":null,"specialMargin":null,"additionalMargin":null,"tenderMargin":null,"adhocMargin":null}],"brokerageHeld":null},"sessionResponse":null,"target":"sucess"}
        // var resp = res['response'];
        document.getElementById('errMsgDiv').innerHTML ="";
        if (errorCount == 0) {
            inputMap.clear();
            if(this.params == "FUTOPT"){
                inputMap.set('Body.marginGroupNo', 1);
                inputMap.set('Body.productType', 13);
            }else if(this.params == "COMDERV"){
                inputMap.set('Body.marginGroupNo', 2);
                inputMap.set('Body.productType', 2);
            }
            
            inputMap.set('Body.clientid', this.cstmInvestorID.cmbInvestorId.getFieldValue());
            this.services.http.fetchApi('/statements/margin/fnostatement', 'POST', inputMap).subscribe(
                async (httpResponse: HttpResponse<any>) => {
                    var res = httpResponse.body;
                  // var res = {"respCode":"0","errMsg":"","response":{"marginsConsolidated":[{"symbol":"GOLD        ","displaySymbol":"114         ","exchangeID":"CSE","openPosBuyQuantity":null,"openPosBuyValue":null,"openPosSellQuantity":null,"openPosSellValue":null,"netPosQuantity":null,"netPosValue":null,"outstandingBuyOrdQty":null,"outstandingBuyOrdVal":null,"outstandingSellOrdQty":null,"outstandingSellOrdVal":null,"marginHeld":0,"currStlQty":null,"currStlVal":null,"currStlMarginHeld":null,"underStlQty":null,"underStlVal":null,"underStlMarginHeld":null,"underAucQty":null,"underAucVal":null,"underAucMarginHeld":null,"totalSSmarginHeld":null,"openPosQtyFromHoldings":null,"openPosShortQty":null,"openPosShortValue":null,"outstandingShortQty":null,"buyOrdermarginHeld":null,"hedgemargin":-922337203685477.6,"totalMargin":-922337203685477.6,"sigmaNetQty":null,"sigmaNetVal":null,"grossExposureMarginHeld":null,"fnoCarryForwardLineEntry":[{"contract":"207226","segment":"CARRYFORWARD","displaySymbol":"FUTCOM-GOLD-05Jun2024-XX","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":30,"outstandingBuyOrdVal":-45000,"outstandingSellOrdQty":0,"outstandingSellOrdVal":0,"marginHeld":0},{"contract":"207229","segment":"CARRYFORWARD","displaySymbol":"FUTCOM-GOLD-05Aug2024-XX","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":20,"outstandingBuyOrdVal":-25000,"outstandingSellOrdQty":0,"outstandingSellOrdVal":0,"marginHeld":0},{"contract":"207002","segment":"CARRYFORWARD","displaySymbol":"FUTCOM-GOLD-05Jul2024-XX","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":40,"outstandingBuyOrdVal":-80000,"outstandingSellOrdQty":-9,"outstandingSellOrdVal":18000,"marginHeld":0},{"contract":"26083","segment":"CARRYFORWARD","displaySymbol":"OPTCOM-GOLD-28May2015-42900.00-CE","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":10,"outstandingBuyOrdVal":-42900000,"outstandingSellOrdQty":0,"outstandingSellOrdVal":0,"marginHeld":25000}],"underlyingLTP":null,"underlyingLastTrdDate":0,"underlyingLastTrdTime":0,"series":null,"segment":null,"buyTradeQuantity":null,"buyTradeValue":null,"sellTradeQuantity":null,"sellTradeValue":null,"shortSellTradeQty":null,"margincreditStockSale":null,"buyOrderQty":null,"buyOrderValue":null,"sellOrderQty":null,"sellOrderValue":null,"shortSellOrderQty":null,"shortSellMarginHeld":null,"specialMargin":null,"additionalMargin":null,"tenderMargin":null,"adhocMargin":null},{"symbol":"SILVER        ","displaySymbol":"114         ","exchangeID":"CSE","openPosBuyQuantity":null,"openPosBuyValue":null,"openPosSellQuantity":null,"openPosSellValue":null,"netPosQuantity":null,"netPosValue":null,"outstandingBuyOrdQty":null,"outstandingBuyOrdVal":null,"outstandingSellOrdQty":null,"outstandingSellOrdVal":null,"marginHeld":0,"currStlQty":null,"currStlVal":null,"currStlMarginHeld":null,"underStlQty":null,"underStlVal":null,"underStlMarginHeld":null,"underAucQty":null,"underAucVal":null,"underAucMarginHeld":null,"totalSSmarginHeld":null,"openPosQtyFromHoldings":null,"openPosShortQty":null,"openPosShortValue":null,"outstandingShortQty":null,"buyOrdermarginHeld":null,"hedgemargin":-922337203685477.6,"totalMargin":-922337203685477.6,"sigmaNetQty":null,"sigmaNetVal":null,"grossExposureMarginHeld":null,"fnoCarryForwardLineEntry":[{"contract":"207226","segment":"CARRYFORWARD","displaySymbol":"FUTCOM-SILVER-05Jun2024-XX","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":30,"outstandingBuyOrdVal":-45000,"outstandingSellOrdQty":0,"outstandingSellOrdVal":0,"marginHeld":0},{"contract":"207229","segment":"CARRYFORWARD","displaySymbol":"FUTCOM-SILVER-05Aug2024-XX","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":20,"outstandingBuyOrdVal":-25000,"outstandingSellOrdQty":0,"outstandingSellOrdVal":0,"marginHeld":0},{"contract":"207002","segment":"CARRYFORWARD","displaySymbol":"FUTCOM-SILVER-05Jul2024-XX","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":40,"outstandingBuyOrdVal":-80000,"outstandingSellOrdQty":-9,"outstandingSellOrdVal":18000,"marginHeld":0},{"contract":"26083","segment":"CARRYFORWARD","displaySymbol":"OPTCOM-SILVER-28May2015-42900.00-CE","exchangeID":"CSE","openPosBuyQuantity":0,"openPosBuyValue":0,"openPosSellQuantity":0,"openPosSellValue":0,"netPosQuantity":0,"netPosValue":0,"outstandingBuyOrdQty":10,"outstandingBuyOrdVal":-42900000,"outstandingSellOrdQty":0,"outstandingSellOrdVal":0,"marginHeld":25000}],"underlyingLTP":null,"underlyingLastTrdDate":0,"underlyingLastTrdTime":0,"series":null,"segment":null,"buyTradeQuantity":null,"buyTradeValue":null,"sellTradeQuantity":null,"sellTradeValue":null,"shortSellTradeQty":null,"margincreditStockSale":null,"buyOrderQty":null,"buyOrderValue":null,"sellOrderQty":null,"sellOrderValue":null,"shortSellOrderQty":null,"shortSellMarginHeld":null,"specialMargin":null,"additionalMargin":null,"tenderMargin":null,"adhocMargin":null}]},"sessionResponse":null,"target":"success"};
                     this.marginsConsolidated = res.response.marginsConsolidated || [];
                     //console.log(this.marginsConsolidated[0].fnoCarryForwardLineEntry)
                    var respCode: any = res['respCode'];
                    if (respCode != null && respCode == 0) {
                        //this.services.alert.showAlert(2, "Failure", -1);
                        //this.gotxGridComp.reloadGrid(res['response'].intraDayMarginList);
                    /*    for(let i=0 ; i<= this.initialData.length ; i++){
                            this.initialData = this.initialData[i].fnoCarryForwardLineEntry;
                           // this.gotxGridComp.reloadGrid(this.initialData[i].fnoCarryForwardLineEntry);
                        
                        }*/
                      
                        //this.gotxGridComp.reloadGrid(this.marginsConsolidated);
                        //this.gotxGridComp.reloadGrid(res['response'].marginsConsolidated);
                    }
                    else {

                        //this.services.alert.showAlert(1, "Sucess", 2000);
                        //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
			//commented by Shanmuga Priya - VAPT
			const rawMsg = res['errMsg'];
			const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
			(document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
                    }
                },
                async (httpError) => {
                    var err = httpError['error']
                    if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
                        if (err['ErrorElementPath'] == 'clientid') {
                            this.cstmInvestorID.cmbInvestorId.setError(err['ErrorDescription']);
                        }
                    }
                    document.getElementById('errMsgDiv').innerHTML =this.transalte('ErrorCodes.SystemDown');
                }
            );
        }
    }
async btnEquityMarginDetailBack_click(event){
    let inputMap = new Map();
    this.services.modal.dismissAll();
    const modalRef = this.services.openModal(gotxModalComponent, 'lg',null, "Buying Power Summary");   
}

    fieldDependencies = {
    }
    transalte(text) {
        return this.services.translate.instant(text);
      }
    /*equity details grid starts*/
    datafields =
        [
            { name: 'displaySymbol', type: 'string' },
            { name: 'exchangeID', type: 'string' },
            { name: 'segment', type: 'string' },
            { name: 'openPosBuyQuantity', type: 'number' },
            { name: 'openPosBuyValue', type: 'number' },
            { name: 'openPosSellQuantity', type: 'number' },
            { name: 'openPosSellValue', type: 'number' },
            { name: 'netPosQuantity', type: 'number' },
            { name: 'netPosValue', type: 'number' },
            { name: 'outstandingBuyOrdQty', type: 'number' },
            { name: 'outstandingBuyOrdVal', type: 'number' },
            { name: 'outstandingSellOrdQty', type: 'number' },
            { name: 'outstandingSellOrdVal', type: 'number' },
            { name: 'marginHeld', type: 'number' }
           // { name: 'margincreditStockSale', type: 'number' }
        ];

    // rowId = "displaySymbol";
    datatype = "json";
     data = [];
    columns: any[] = [
       
        { text: this.transalte('EquityMarginDetailGrid.Exchange'), datafield: 'exchangeID', width: "10%", cellsalign: 'left', align: 'center' , columngroup: 'tableHeader' },
        { text: this.transalte('EquityMarginDetailGrid.Symbol'), datafield: 'displaySymbol', width: "28%", cellsalign: 'left', align: 'center', columngroup: 'tableHeader'  },
        { text: this.transalte('EquityMarginDetailGrid.Segment'), datafield: 'segment', width: "15%", cellsalign: 'left', align: 'center' , columngroup: 'tableHeader' },

        { text: this.transalte('EquityMarginDetailGrid.Qty'), datafield: 'openPosBuyQuantity', cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'buyOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'openPosBuyValue', cellsformat: 'f2' ,width: "13%", cellsalign: 'right', align: 'center', columngroup: 'buyOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Qty'), datafield: 'openPosSellQuantity',cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'sellOpenPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'openPosSellValue', cellsformat: 'f2' ,width: "13%", cellsalign: 'right', align: 'center', columngroup: 'sellOpenPosition' },

        { text: this.transalte('EquityMarginDetailGrid.NetQty'), datafield: 'netPosQuantity',cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'netPosition' },
        { text: this.transalte('EquityMarginDetailGrid.NetValue'), datafield: 'netPosValue', cellsformat: 'f2' ,width: "13%", cellsalign: 'right', align: 'center', columngroup: 'netPosition' },

        { text: this.transalte('EquityMarginDetailGrid.Qty'), datafield: 'outstandingBuyOrdQty', cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'yyyy' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'outstandingBuyOrdVal',cellsformat: 'f2' , width: "13%", cellsalign: 'right', align: 'center', columngroup: 'yyyy' },
        { text:this.transalte( 'EquityMarginDetailGrid.Qty'), datafield: 'outstandingSellOrdQty', cellsformat: 'n' ,width: "7%", cellsalign: 'right', align: 'center', columngroup: 'zzzz' },
        { text: this.transalte('EquityMarginDetailGrid.Value'), datafield: 'outstandingSellOrdVal',cellsformat: 'f2' , width: "13%", cellsalign: 'right', align: 'center', columngroup: 'zzzz' },
        { text: this.transalte('EquityMarginDetailGrid.MarginHeld'), datafield: 'marginHeld',cellsformat: 'f2' , width: "17%", cellsalign: 'right', align: 'center' , columngroup: 'outstandingOrder' },

    ];
    columngroups: any[] = [
        { text: this.transalte('EquityMarginDetailGrid.OpenPosition'), align: 'center', name: 'openPosition', parentgroup: 'tableHeader' },
        { text: this.transalte('EquityMarginDetailGrid.NetPosition'), align: 'center', name: 'netPosition', parentgroup: 'tableHeader' },
        { text: this.transalte('EquityMarginDetailGrid.OutstandingOrder'), align: 'center', name: 'outstandingOrder',parentgroup: 'tableHeader'},
        
        { text: this.transalte('EquityMarginDetailGrid.Buy'), align: 'center', name: 'buyOpenPosition', parentgroup: 'openPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Sell'), align: 'center', name: 'sellOpenPosition', parentgroup: 'openPosition' },
        { text: this.transalte('EquityMarginDetailGrid.Buy'), align: 'center', name: 'yyyy', parentgroup: 'outstandingOrder' },
        { text: this.transalte('EquityMarginDetailGrid.Sell'), align: 'center', name: 'zzzz', parentgroup: 'outstandingOrder' },

    ];

    /*equity details grid ends*/
    /*async btnExport_click(event) {
        if (this.gotxGridComp.gotxGrid.getrows().length <= 0) {
            this.services.alert.showAlert(2, "There is No Data to export", -1);
        } else {
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeQty', 'text',this.transalte('EquityMarginDetailGrid.BuyTradeQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeValue', 'text', this.transalte('EquityMarginDetailGrid.BuyTradeValue'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeQty', 'text', this.transalte('EquityMarginDetailGrid.SellTradeQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeValue', 'text', this.transalte('EquityMarginDetailGrid.SellTradeValue'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderQty', 'text', this.transalte('EquityMarginDetailGrid.BuyOrderQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderValue', 'text', this.transalte('EquityMarginDetailGrid.BuyOrderValue'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderQty', 'text', this.transalte('EquityMarginDetailGrid.SellOrderQty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderValue', 'text', this.transalte('EquityMarginDetailGrid.SellOrderValue'));
          
            this.gotxGridComp.gotxGrid.exportdata('csv', "Equity_Position_Margin");
            
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyTradeValue', 'text', this.transalte('EquityMarginDetailGrid.Value'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellTradeValue', 'text', this.transalte('EquityMarginDetailGrid.Value'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('buyOrderValue', 'text',this.transalte('EquityMarginDetailGrid.Value'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderQty', 'text', this.transalte('EquityMarginDetailGrid.Qty'));
            this.gotxGridComp.gotxGrid.setcolumnproperty('sellOrderValue', 'text', this.transalte('EquityMarginDetailGrid.Value'));
        }
    }*/
        /*btnExport_click(event,id) {
            console.log("id",id);
            console.log("event",event);*/
           // const targetGrid = this.gotxGridComponents.find(comp => comp.id === id);
           /* if (targetGrid) {
                // Access rows and export data
                const rows = targetGrid.getrows();
                targetGrid.exportdata('xls', targetGrid);
              } else {
                console.warn(Grid with ID ${id} not found.);
              }*/
            
           // const rows = this.gotxGridComponents.gotxGrid.getrows();
          /* console.log("this",this);
            const rows = id.gotxGridComponents.getrows();
            //const columns = this.gotxGridComponents.gotxGrid.attrColumns;
            console.log("rows",rows);
            const columns = id.gotxGridComponents.attrColumns;
            console.log("columns",columns);
            this.services.dataStore.exportGridFunction(rows,columns,"Derivative_Margin");*/
            //this.exportGridToExcel();
            /*this.exportToExcel();
           }*/

           btnExport_click_new(event,id){
            console.log("id",id);
            console.log("event",event);
            
           var rows = this.gotxGridComp.gotxGrid.getrows;
           console.log("rows",rows);
           }
           
        /*exportGridToExcel() {
            // Convert grid data to SheetJS format
            const ws = XLSX.utils.json_to_sheet(this.columns);
          
            // Define the header names (from your grid structure)
            const header = ["Exchange", "Symbol"];
            XLSX.utils.sheet_add_aoa(ws, [header], { origin: "A1" });
          
            // Create workbook and add worksheet
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "EquityMarginDetailGrid");
          
            // Export to Excel file
            XLSX.writeFile(wb, "EquityMarginDetailGrid.xlsx");
          }*/
            exportToExcel(): void {
                // Step 1: Create an HTML table string
                let table = '<table border="1">';
            
                // Table Header
                table += '<tr>';
                this.columns.forEach(column => {
                  table += `<th>${column.text}</th>`;
                });
                table += '</tr>';
            
                // Table Rows
                this.data.forEach(row => {
                  table += '<tr>';
                  this.columns.forEach(column => {
                    console.log("row[column.datafield]",row[column.datafield]);
                    table += `<td>${row[column.datafield] || ''}</td>`;
                  });
                  table += '</tr>';
                });
                table += '</table>';
            
                // Step 2: Convert the HTML table string to a Blob
                const blob = new Blob([table], { type: 'application/vnd.ms-excel' });
            
                // Step 3: Save the Blob as an .xls file
               // saveAs(blob, 'grid_data.xls');
               const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                //a.download = 'export.xls';
                a.download = "Derivative Margin" + '.xls';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }

}